import React from "react"

import { convertHtmlToReact } from "@hedgedoc/html-to-react"
import type { LinkProps } from "react-router-dom"

/**
 * Class for working with html strings
 */
export class HtmlHelper {
    /**
     * Convert HTML link to JSX
     * With replacing local links with <Link> tag, so page is not reloaded when clicked
     */
    static convertHtmlStringToJSX(
        html: string,
        RouterDomLink?: React.ForwardRefExoticComponent<LinkProps>,
    ): (React.JSX.Element | string | null)[] {
        const result = convertHtmlToReact(html)

        // Replace all local <a> tags with react router <Link>, so page is not reloaded
        return result.map(
            (
                item: React.JSX.Element | null | string,
                index: number,
            ): React.JSX.Element | string | null => {
                if (
                    !item ||
                    !RouterDomLink ||
                    typeof item === "string" ||
                    item.type !== "a"
                ) {
                    return item
                }

                if (
                    HtmlHelper.isExternalLink(
                        item.props.href,
                        item.props.target,
                    )
                ) {
                    return item
                }

                return (
                    <RouterDomLink key={index} to={item.props.href}>
                        {item.props.children}
                    </RouterDomLink>
                )
            },
        )
    }

    /**
     * Check if link is external
     */
    static isExternalLink(url: string, target?: string): boolean {
        return /^https?:\/\//.test(url) || target === "_blank"
    }
}
